import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-color',
  templateUrl: './color-form-field.component.html',
  styleUrls: ['./color-form-field.component.scss'],
  standalone: false,
})
export class ColorFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  color: string;

  ngOnDestroy() {}

  ngOnInit(): void {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    this.color = formControl.value;
  }

  changeColor($event) {
    this.formGroup.get(this.fieldConfig.name).setValue($event);
  }
}
